import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setFavourites = info => {
	return {
		type: ActionTypes.LOAD_FAVOURITES,
		favourites: info.data
	};
};

export const loadFavourites = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/favoritos")
			.then(response => {
				dispatch(setFavourites(response.data));
			})
			.catch(error => {});
	};
};
